import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DashboardReadsService } from 'src/app/services/dashboard-reads.service';

/**
 * Tras una escritura a la API (POST, PUT, PATCH o DELETE: guardar la empresa,
 * una sede, un empleado, firmar, cambiar de plan…), las lecturas guardadas
 * durante la navegación (`DashboardReadsService`) ya no valen: se olvidan,
 * haya ido bien o no, y la siguiente lectura trae lo nuevo.
 */
@Injectable()
export class ForgetReadsInterceptor implements HttpInterceptor {
  constructor(private reads: DashboardReadsService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.method === 'GET' || req.method === 'HEAD' || !targetsOwnApi(req.url)) return next.handle(req);
    return next.handle(req).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) this.reads.forget();
        },
        error: () => this.reads.forget(),
      }),
    );
  }
}

function targetsOwnApi(url: string): boolean {
  return [environment.laravelApi, environment.laravelBackoffice].some((base) => !!base && url.startsWith(base));
}
